export default {
  "base": "my-5 leading-7 text-pretty"
}